module.exports = __webpack_public_path__ + "img/friend.3adb99d2.svg";